export default "__VITE_ASSET__af3e68a0__"